<template>
  <v-row justify="center" class="mt-4">
    <v-col cols="12" md="10" lg="10">
      <v-card color="transparent" flat class="pa-4">
        <v-row>
          <v-col>
            <v-btn icon @click="volver" class="mb-4">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <v-list-item>
              <v-list-item-avatar>
                <v-icon x-large :color="categoriaDetalles.color"
                  >mdi-checkbox-multiple-blank-circle</v-icon
                >
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  ><span class="text-h5">{{
                    categoriaDetalles.categoria
                  }}</span></v-list-item-title
                >
                <v-list-item-title>{{
                  categoriaDetalles.fechaPeriodo
                }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="d-flex align-center">
                <span class="text-h5 mr-2">
                  {{ categoriaDetalles.acumulado | convertPesoArg }}
                </span>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  ><span class=""
                    >Tenés {{ categoriaDetalles.total_detalles }} gastos</span
                  ></v-list-item-title
                >
              </v-list-item-content>

              <v-list-item-action class="d-flex align-center">
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-4">
          <v-col cols="10">
            <v-list color="transparent" two-line class="m-4">
              <!-- Iterar tipos de gasto -->
              <v-list-group
                v-for="tipo in categoriaDetalles.gastos || []"
                :key="tipo.tipoIngresoEgresoDescripcion"
                no-action
                :value="tipo.detalles.length <= 10"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ tipo.tipoIngresoEgresoDescripcion }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span v-if="categoriaDetalles.gastos.length > 1">
                      {{ tipo.acumulado | convertPesoArg }}
                    </span>
                    <span v-if="tipo.detalles.length > 10">
                      {{ tipo.detalles.length }}</span
                    >
                  </v-list-item-action>
                </template>

                <!-- Gastos dentro de cada tipo -->
                <v-list-item
                  v-for="detalle in tipo.detalles"
                  :key="detalle.id"
                  @click="handleClick(detalle)"
                  class="hoverable"
                >
                  <v-list-item-avatar>
                    <v-icon large> mdi-cash-minus</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ detalle.descripcion || "Sin descripción" }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ detalle.user || "Usuario no especificado" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <div class="d-flex flex-column align-end">
                      <span class="text-subtitle-1"
                        >- {{ detalle.monto | convertPesoArg }}</span
                      >
                      <span class="text-subtitle-2 grey--text">
                        {{ moment(detalle.fechaAlta).format("DD/MMM") }}
                      </span>
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-col>
        </v-row>
        <!-- <v-row justify="center" class="mt-4">
          <v-col cols="10">
            <v-list color="transparent" two-line class="m-4">
              <v-list-item
                v-for="gasto in categoriaDetalles.gastos.detalles || []"
                :key="gasto.id"
                @click="handleClick(gasto)"
                class="hoverable"
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                       gasto.descripcion || "Sin descripción"
                  }}</v-list-item-title>
                
                </v-list-item-content>
                <v-list-item-action>
                  <span class="font-weight-bold mr-3"> - {{
                    gasto.monto | convertPesoArg
                  }}</span>
                 
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row> -->

        <v-dialog v-model="dialogVistaPrevia" max-width="600px">
          <egreso-vista-previa
            v-if="dialogVistaPrevia"
            :egreso="egreso"
            @close-dialog="dialogVistaPrevia = false"
          />
        </v-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import EgresoVistaPrevia from "@/views/empresa/sucursales/egresos/components/egreso.preview.vue";

export default {
  name: "GastosSucursalList",
  components: {
    EgresoVistaPrevia,
  },
  data() {
    return {
      categoriaDetalles: null,
      egreso: null,
      dialogVistaPrevia: false,
    };
  },
  computed: {
    categoria() {
      return this.$route.params.categoria || null;
    },
  },

  methods: {
    handleClick(egreso) {
      console.log(egreso);
      var gasto = {
        detalles: [ egreso ],
        categoria: { name: this.categoriaDetalles.categoria },
        tipoIngresoEgreso: { descripcion: egreso.tipoIngresoEgreso },
        total: egreso.monto,
        id: egreso.id // Total del gasto (monto principal) ( no suma de detalles, para el futuro cuando haya varios detalles hay que cambiar esto)
      };
      console.log(egreso.monto);
      
      console.log(gasto);

      this.egreso = gasto;
      this.dialogVistaPrevia = true;
    },
    volver() {
      this.$router.push({
        name: "SucursalEgresosGastosCategoria",
      });
    },
    async fetchEgresos() {
      try {
        console.log("Fetching egresos for category:", this.categoria);

        const params = new URLSearchParams();
        const fechaPeriodo = this.$route.query.fechaPeriodo;
        const categoriaId = this.$route.query.categoria;
        if (fechaPeriodo) {
          params.append("fechaPeriodo", fechaPeriodo);
        }
        if (categoriaId) {
          params.append("categoria", categoriaId);
        }

        // ⚡️ Agrega el filtro de sucursal
        const sucursalUUID = this.$route.params.uuid_sucursal;

        if (sucursalUUID) {
          params.append("sucursal_uuid", sucursalUUID);
        }

        const response = await this.axios.get(
          `/egresos/gastos?${params.toString()}`
        );
        console.log("Egresos response:", response.data);

        if (response.data.length > 0) {
          this.categoriaDetalles = response.data[0];
        } else {
          this.categoriaDetalles = {
            categoria: "Sin categoría",
            fechaPeriodo: "No disponible",
            acumulado: 0,
            total_detalles: 0,
            gastos: [],
          };
        }
      } catch (error) {
        this.volver();
        console.error("Error al cargar egresos:", error);
      }
    },
  },
  // watch: {
  //   categoria: {
  //     immediate: true,
  //     handler(nuevaCategoria) {
  //       this.categoriaDetalles = nuevaCategoria;
  //     },
  //   },
  // },
  created() {
    if (!this.$route.params.categoria) {
      this.fetchEgresos();
    } else {
      this.categoriaDetalles = this.$route.params.categoria;
    }
  },
  filters: {
    convertPesoArg(value) {
      if (!value) return "$ 0";
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.hoverable:hover {
  background-color: #f5f5f5;
}
.text-center {
  text-align: center;
}
</style>
